import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [],
  deliveryMen: [],
};

export const UserSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    addUser: (state, action) => {
      state.users.push(action.payload);
    },
    addDeliveryMan: (state, action) => {
      state.deliveryMen.push(action.payload);
    },
    addUsers: (state, action) => {
      state.users = action.payload.users;
    },
    addDeliveryMen: (state, action) => {
      state.deliveryMen = action.payload.users;
    },
    updateUser: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.users.findIndex(user => user.id === id);
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...newData };
      }
    },
    updateDeliveryMan: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.deliveryMen.findIndex(user => user.id === id);
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...newData };
      }
    },
  },
});

export const { addUser, addUsers, updateUser, addDeliveryMan, addDeliveryMen, updateDeliveryMan } = UserSlice.actions;

export default UserSlice.reducer;